module.exports = {
  contact: 'Kontakt',
  rating: 'Bewertung',
  title: 'Feedback / App bewerten',
  your_feedback: 'Dein Feedback',
  feedback_is_send_to: 'Dein Feedback wird an %{appName} gesendet.',
  your_feedback_item_feedback: 'Deine Nachricht',
  title_item_feedback: 'Frage / Antwort melden',
  submit_item_feedback: 'Senden',
  submit: 'Feedback & Bewertung senden',
  feedback_item: {
    link: 'Schick uns dein Feedback >',
    text: 'Du möchtest uns etwas mitteilen?',
  },
  thanks_for_rating_us: 'Vielen Dank für dein Feedback!',
  description_item_feedback: 'Bitte teile uns dein Feedback zu diesem Inhalt mit. Wenn du möchtest, kannst du auch gerne Links zu entsprechenden Nachweisen hinzufügen.',
  we_will_consider_it: 'Wir werden uns dein Feedback in Ruhe ansehen und berücksichtigen!',
}
